export default __webpack_public_path__ + "static/media/Harness of Rapturous Battle.cc06c29b.jpg";